//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Questions Right Component File
//  * @description -   This file renders the html and functionality that renders at right panel when questions tab is selected.
<template>
  <div class="col-md-3 p-0 col-xs-12 survey_colume_3">
    <!-- <div class="colume_3_option sticky_bar" v-if="qid==''">
    </div>-->

    <!-- <div v-if="!qid" class="colume_3_build sticky_bar margin-top-78">
      <img src="../../assets/images/bulb_img.png" alt="blub image" class="img-responsive">

      <div class="build_text">
        <h3>building a survey is easy!</h3>
        <span>follow three simple steps:</span>

        <ul class="build_staps">
          <li>
            <i class="fa fa-check-square-o" aria-hidden="true"></i>choose setting
          </li>
          <li>
            <i class="fa fa-check-square-o" aria-hidden="true"></i>decide on design
          </li>
          <li>
            <i class="fa fa-square-o" aria-hidden="true"></i>create your questions
          </li>
        </ul>
      </div>
    </div>-->
    <div v-show="qid">
      <div class="colume_3_option sticky_bar">
        <div class="colume_3_option_tab">
          <ul class="nav">
            <li>
              <a class="active" data-toggle="tab" href="#questions">
                <!-- <div class="t-length icon-edit">
                  <i :class="className" aria-hidden="true"></i>
                </div> -->
                <span v-if="qid > 0">Question {{qid}}</span>
                <span v-else-if="qid == -1">Start Screen</span>
                <span v-else>End Screen</span>
              </a>
            </li>
            <li :class="all.in_survey_type == 4 ? 'cursor_not_allowed': ''">
              <a
                href="#"
                :class="all.in_survey_type == 4 ? ' disable_kiosk_control': ''"
                @click="questionUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : updateSkipLogic()"
              >Skip logic</a>
            </li>
          </ul>
        </div>
        <div class="colume_1_option_elements">
          <div class="tab-content">
            <div id="questions" class="tab-pane fade in active">
              <div class="choise_save">
                <QuestionControl></QuestionControl>
              </div>
            </div>
            <!-- Skip Logic starts here -->
            <!-- <div id="skip_logic" class="tab-pane fade">
              <div class="choise_save">
                <div class="edit_box">
                  <h4 class="edit_head">answer choies</h4>
                  <div class="answer_choies">
                    <input type="text" class="form-control" placeholder="Type Your option 1">
                    <a href="#" class="delete_icon">
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="answer_choies">
                    <input type="text" class="form-control" placeholder="Type Your option 2">
                    <a href="#" class="delete_icon">
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="answer_choies">
                    <input type="text" class="form-control" placeholder="Type Your option 3">
                    <a href="#" class="delete_icon">
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="answer_choies">
                    <input type="text" class="form-control" placeholder="Type Your option 4">
                    <a href="#" class="delete_icon">
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="answer_choies">
                    <a href="#" class="add_more_fild">
                      <i class="fa fa-plus" aria-hidden="true"></i> add more answer
                    </a>
                  </div>
                </div>

                <div class="edit_box">
                  <h4 class="edit_head">answer option</h4>
                </div>

                <div class="edit_box display-flex">
                  <div class="answer_btn">
                    <label class="switch">
                      <input type="checkbox">
                      <span class="slider round"></span>
                    </label>
                    <p>required answer</p>
                  </div>
                  <div class="answer_btn">
                    <label class="switch">
                      <input type="checkbox">
                      <span class="slider round"></span>
                    </label>
                    <p>allow other answer</p>
                  </div>
                  <div class="answer_btn">
                    <label class="switch">
                      <input type="checkbox">
                      <span class="slider round"></span>
                    </label>
                    <p>allow multiple aswer</p>
                  </div>
                </div>

                <div class="edit_box">
                  <h4 class="edit_head">media manager</h4>

                  <div class="add_image">
                    <span>Add image</span>

                    <input type="file" value="upload File or drag and drop the file here">
                  </div>
                </div>
                <div class="edit_box">
                  <div class="end_save_btn save_cancel">
                    <a href="#">cancel</a>
                    <a href="#">
                      <span>save changes</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import QuestionControl from "./RightBarComponents/QuestionControl";
export default {
  name: "rightquestions",
  data() {
    return {
      qid: "",
      className: ""
    };
  },
  computed: {
    ...mapGetters("editquestionEdit", ["isSkipLogic", "questionUpdated"]),
    ...mapGetters("LeftSidebarCreate",["all"])
  },
  mounted: function() {
    EventBus.$on("questionTypeSelected", qtype => {
      if (qtype.qid) {
        this.qid = qtype.qid;
        this.className = qtype.className;
      } else {
        qtype.id == "17"
          ? (this.qid = "-1")
          : qtype.id == "18"
          ? (this.qid = "-2")
          : (this.qid = "");
        this.className = qtype.className;
      }
    });
  },
  beforeDestroy() {
    this.qid = "";
    EventBus.$off("questionTypeSelected");
  },
  components: {
    QuestionControl
  },
  methods: {
    ...mapActions("editquestionEdit", ["setIsSkipLogic"]),
    updateSkipLogic() {
      let val = {};
      val.skipLogic = true;
      val.qno = parseInt(this.qid) - 1;
      this.setIsSkipLogic(val);
    },
    callSaveMethod: function() {
      EventBus.$emit("saveQuestionFromCenterQuestions");
    },
    callCancelMethod: function() {
      EventBus.$emit("cancelQuestionFromCenterQuestions");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/rightquestions.vue